import type { State } from '../State';
import {
  AccessoryItem,
  AccessoryItemID,
  accessoryItems,
  accessoryItemsMap,
  AccessoryTier,
  AccessoryTierID,
  tiersAccessoryItemsMap,
} from './accessory.ruleset';
import { SelectedAccessoryState } from './accessory.schema';

/**
 * Get equipped accessory by id
 */
export function getSelectedItemByID(
  state: State,
  id: AccessoryItemID,
): AccessoryItem | undefined {
  const item = state.accessory.selected.find((items) => items.id === id);
  if (!item) return undefined;

  const data = getAccessoryItem(item.id as AccessoryItemID);

  return data;
}

/**
 * Get all items available for slot equipment
 */
export function getAvailableAccessories(): AccessoryItem[] {
  // Filter selected items and return typed objects array
  const available = accessoryItems.map((item) => getAccessoryItem(item.id));

  return available;
}

/**
 * Get accessory item by id
 */
export function getAccessoryItem(id: AccessoryItemID): AccessoryItem {
  return accessoryItemsMap.get(id)!;
}
/*
 * Check if item is purchased
 */
export function isAccessoryPurchased(
  state: State,
  id: AccessoryItemID,
): boolean {
  const stateData = state.accessory.purchased[id];

  // Purchase state does not exist, so item is not purchased.
  if (!stateData) return false;

  // Otherwise check if user has any tier of item.
  const tiers = Object.values(stateData.tier);
  return tiers.reduce((acc, { quantity }) => acc + quantity, 0) > 0;
}

/*
 * Get all selected accessories in pure state representation
 */
export function getSelectedAccessoryState(
  state: State,
): SelectedAccessoryState[] {
  return state.accessory.selected as SelectedAccessoryState[];
}
/**
 * Get accessory item tier.
 * @param id
 * @param tierId
 * @returns
 */
export function getAccessoryItemTier(
  id: AccessoryItemID,
  tierId: AccessoryTierID,
): AccessoryTier {
  return tiersAccessoryItemsMap[id][tierId];
}

/**
 * Get accessory tier by number.
 * @param id
 * @param tierNumber
 */
export function getAccessoryTierByNumber(
  id: AccessoryItemID,
  tierNumber: number,
): AccessoryTier | undefined {
  return Object.values(tiersAccessoryItemsMap[id] ?? {}).find(
    (tierItem) => tierItem.tier === tierNumber,
  );
}
/**
 * Get highest accessory tier.
 * @param id
 * @returns
 */
export function getHighestAccessoryTier(id: AccessoryItemID): number {
  return accessoryItemsMap.get(id)!.max_tier;
}
